(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('QueueDetailController', QueueDetailController);

    QueueDetailController.$inject = ['$stateParams', '$state', 'Queue', 'ParseLinks', 'AlertService', 'TabActionsQueueRetry', 'pagingParams', 'paginationConstants', 'entity'];

    function QueueDetailController($stateParams, $state, Queue, ParseLinks, AlertService, TabActionsQueueRetry, pagingParams, paginationConstants, entity) {
        var vm = this;
        vm.queue = [];
        vm.timeline = [];
        vm.timelines = [];
        vm.showCommand = {};

        // Add the new function
        vm.getActionDisplayName = getActionDisplayName;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.queue = entity;
                if (vm.queue.licenseExpirationDate != null) {
                    vm.queue.licenseExpirationDate = new Date(vm.queue.licenseExpirationDate);
                }
                vm.queue.queueCommands.sort(function (a, b) {
                    var commandA = a.order, commandB = b.order;
                    return commandA-commandB;
                });
                vm.queue.queueCommands.sort(function (a, b) {
                    var dateA = new Date(a.executionDatetime), dateB = new Date(b.executionDatetime);
                    return dateA-dateB;
                });
                var c = 0;
                for(var i = 0; i < vm.queue.queueCommands.length; i++){
                    if(vm.queue.queueCommands[i].executionDatetime == null){
                        var temp = vm.queue.queueCommands[i];
                        vm.queue.queueCommands.splice(i, 1);
                        vm.queue.queueCommands.push(temp);
                        i--;
                    } else {
                        break;
                    }
                    if(c == vm.queue.queueCommands.length -1){
                        break;
                    }
                    c++;
                }
                c = 0;
                for(var i = 0; i < vm.queue.queueCommands.length; i++){
                    if(c < 10 && c < vm.queue.queueCommands.length){
                        vm.timeline.push(vm.queue.queueCommands[i]);
                    } else {
                        vm.timelines.push(vm.timeline);
                        vm.timeline = [];
                        c = 0;
                        vm.timeline.push(vm.queue.queueCommands[i]);
                    }
                    c++;
                }
                vm.timelines.push(vm.timeline);
            });
        }

        vm.findIndexCommand = function (command, timeline){
            for(var i = 0; i < timeline.length; i++){
                if(timeline[i].id == command.id){
                    return (i*10)+4;
                }
            }
        };

        vm.printCommand = function(command, index){
            Object.keys(vm.showCommand).forEach(function (key) {
                vm.showCommand[key] = false;
            })
            vm.showCommand[index] = true;
            vm.command = command;
        }

        vm.isEmpty = function (argumentMap) {
            return Object.keys(argumentMap).length > 0;
        }

        /**
         * Get the display name for the command action.
         * For non-Greengrass: returns actions.actionCommand
         * For Greengrass: extracts action from response field
         */
        function getActionDisplayName(command) {
            // If actions exists (non-Greengrass), use it
            if (command.actions && command.actions.actionCommand) {
                return command.actions.actionCommand;
            }

            //// For Greengrass commands, extract from response
            //if (command.response) {
            //    return extractActionFromResponse(command.response);
            //}

            return command.commandName;
        }

        /**
         * Extract action name from response field
         * Handles both plain string "RESET_VIDEO_BOARD_A" and JSON {"action":"RESET_VIDEO_BOARD_A",...}
         */
        function extractActionFromResponse(response) {
            if (!response || response.trim() === '') {
                return 'Unknown Action';
            }

            var trimmedResponse = response.trim();

            // Check if it's JSON (starts with '{')
            if (trimmedResponse.charAt(0) === '{') {
                try {
                    var jsonObj = JSON.parse(trimmedResponse);
                    if (jsonObj.action) {
                        return jsonObj.action;
                    }
                    return 'Unknown Action';
                } catch (e) {
                    console.warn('Failed to parse response as JSON:', trimmedResponse);
                    return 'Unknown Action';
                }
            } else {
                // Plain string - return as is
                return trimmedResponse;
            }
        }

    }
})();
